module.exports = __webpack_public_path__ + "static/media/t_1.4c3bf97e.jpg";